<template>
  <div>

    <!-- User Interface controls -->

    <b-row>
      <b-col md="8">
        <h4 class="font-weight-bold ml-1">Kunder</h4>
      </b-col>

      <!-- Improved customer search input -->
      <b-col md="3" class="d-flex justify-content-end align-items-center">
        <b-form inline class="mb-0 w-100">
          <b-input-group>
            <b-input-group-prepend is-text>
              <i class="ion ion-ios-search"></i>
            </b-input-group-prepend>
            <b-form-input
              v-model="filter"
              @input="onFilterChange"
              @keyup.enter="onFilterChange"
              placeholder="Søk kunde"
              class=""
            />
          </b-input-group>
        </b-form>
      </b-col>
      <b-col md="1" class="d-flex justify-content-end align-items-center">
        <b-button variant="primary" @click="openNewCustomer" class="w-100">
          Ny kunde
        </b-button>
      </b-col>
    </b-row>

    <!-- Main table element -->
    <div>
      <b-table
        show-empty
        caption-top
        stacked="sm"
        :items="filterCompany"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-direction="sortDirection"
        :hover="hoverTable"
        empty-text="There are no orders to show"
        @row-clicked="(item) => $set(item, '_showDetails', !item._showDetails)"
      >
        <template v-slot:table-caption>
          Totalt: {{ filterCompany.length | numeralFormat }} kunder
        </template>

        <template v-slot:cell(mysite)="data">
          <span v-if="data.item.mysite == false"></span>
          <span v-if="data.item.mysite == true">Minside</span>
        </template>

        <template #cell(actions)="row">
          <b-button
            variant="primary"
            class="mr-1 float-center"
            size="sm"
            @click="openEditCustomer(row.item)"
          >
            Rediger</b-button>
        </template>
      </b-table>

      <b-row>
        <b-col
          md="1"
          class="my-1"
        >
          <b-form-group class="mb-0">
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col
          md="2"
          class="my-1"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>

    <!-- Edit Customer Modal -->
    <b-modal
      id="editCustomerModal"
      v-model="showEditCustomerModal"
      title="Rediger kunde"
      @hide="resetEditCustomer"
      ok-title="Lagre"
      cancel-title="Avbryt"
      @ok="saveCustomer"
      size="xl"

    >
      <b-form @submit.stop.prevent="saveCustomer">
        <b-row>
          <b-col md="6">
            <b-form-group label="Navn">
              <b-form-input v-model="editCustomer.name" required />
            </b-form-group>
            <b-form-group label="Org. nummer">
              <b-form-input v-model="editCustomer.orgnumber" />
            </b-form-group>
            <b-form-group label="Adresse">
              <b-form-input v-model="editCustomer.address" />
            </b-form-group>
            <b-form-group label="Postnummer">
              <b-form-input v-model="editCustomer.postcode" />
            </b-form-group>
            <b-form-group label="By">
              <b-form-input v-model="editCustomer.city" />
            </b-form-group>
            <b-form-group label="Land">
              <b-form-input v-model="editCustomer.country" />
            </b-form-group>
            <b-form-group label="Nettside">
              <b-form-input v-model="editCustomer.website" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Kontaktperson">
              <b-form-input v-model="editCustomer.contact" />
            </b-form-group>
            <b-form-group label="Telefon">
              <b-form-input v-model="editCustomer.contact_phone" />
            </b-form-group>
            <b-form-group label="E-post">
              <b-form-input v-model="editCustomer.email" />
            </b-form-group>
            <b-form-group label="Faktura e-post">
              <b-form-input v-model="editCustomer.invoice_email" />
            </b-form-group>
            <b-form-group label="Faktura adresse">
              <b-form-input v-model="editCustomer.invoice_address" />
            </b-form-group>
            <b-form-group label="Faktura postnummer">
              <b-form-input v-model="editCustomer.invoice_postcode" />
            </b-form-group>
            <b-form-group label="Faktura by">
              <b-form-input v-model="editCustomer.invoice_city" />
            </b-form-group>
            <b-form-group label="Faktura EHF">
              <b-form-input v-model="editCustomer.invoice_ehf" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <br />
  </div>
</template>

<script>
import axios from "axios";
import Datepicker from "vuejs-datepicker";
import _ from "lodash";

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      customers: [],
      order: {},
      orders: [],
      lastUpdate: {},
      fields: [
        { key: "name", label: "Kunde", sortable: true },
        { key: "orgnumber", label: "Org. nummer", sortable: true },
        { key: "address", label: "Adresse", sortable: true },
        { key: "contact", label: "Kontaktperson", sortable: true },
        { key: "contact_phone", label: "Telefon", sortable: true },
        { key: "email", label: "E-post", sortable: true },
        { key: "actions", label: "Handlinger" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [25, 50, 100, 250, 500, 1000],
      sortBy: "name",
      sortDesc: true,
      sortDirection: "desc",
      filter: null,
      hoverTable: true,
      limit: 1000,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      isLoading: false,
      fullPage: true,
      showEditCustomerModal: false,
      editCustomer: {
        id: null,
        name: "",
        orgnumber: "",
        address: "",
        postcode: "",
        city: "",
        country: "",
        contact: "",
        contact_phone: "",
        email: "",
        website: "",
        invoice_email: "",
        invoice_address: "",
        invoice_postcode: "",
        invoice_city: "",
        invoice_ehf: ""
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    sumOrdersTotal() {
      return this.orders.length;
    },
    filterCompany() {
      return [
        ...new Map(this.customers.map((item) => [item.name, item])).values(),
      ];
    },
  },
  methods: {
    getOrders() {
      this.isLoading = true;
      axios
        .get("https://api.eines-as.no/companies?_sort=name:ASC")
        .then((res) => {
          this.customers = res.data;
          this.isLoading = false;
        });
    },
    updateOrders() {
      this.isLoading = true;
      var company = localStorage.getItem("company");
      axios
        .get(
          "https://api.eines-as.no/orders?_sort=createdAt:DESC&_where[supplier_company]=" +
            company
        )
        .then((res) => {
          this.orders = res.data;
          this.removeDuplicates();
          this.isLoading = false;
        });
    },
    openEditCustomer(customer) {
      // Copy all relevant fields for editing
      this.editCustomer = {
        id: customer.id || customer._id,
        name: customer.name || "",
        orgnumber: customer.orgnumber || "",
        address: customer.address || "",
        postcode: customer.postcode || "",
        city: customer.city || "",
        country: customer.country || "",
        contact: customer.contact || customer.contact_name || "",
        contact_phone: customer.contact_phone || "",
        email: customer.email || customer.contact_email || "",
        website: customer.website || "",
        invoice_email: customer.invoice_email || "",
        invoice_address: customer.invoice_address || "",
        invoice_postcode: customer.invoice_postcode || "",
        invoice_city: customer.invoice_city || "",
        invoice_ehf: customer.invoice_ehf || ""
      };
      this.showEditCustomerModal = true;
    },
    openNewCustomer() {
      this.resetEditCustomer();
      this.showEditCustomerModal = true;
    },
    resetEditCustomer() {
      this.editCustomer = {
        id: null,
        name: "",
        orgnumber: "",
        address: "",
        postcode: "",
        city: "",
        country: "",
        contact: "",
        contact_phone: "",
        email: "",
        website: "",
        invoice_email: "",
        invoice_address: "",
        invoice_postcode: "",
        invoice_city: "",
        invoice_ehf: ""
      };
    },
    saveCustomer() {
      if (!this.editCustomer.id) {
        // Optionally handle new customer creation here
        return;
      }
      axios
        .put(
          `https://api.eines-as.no/companies/${this.editCustomer.id}`,
          this.editCustomer
        )
        .then(() => {
          this.showEditCustomerModal = false;
          this.getOrders();
        })
        .catch(() => {
          // Optionally handle error
        });
    },
    editOrder(orderId) {
      this.$router.push("/dashboard/order-edit/" + orderId);
    },
    removeDuplicates() {
      this.orders.customer_name = [...new Set(this.orders)];
    },
    onFilterChange: _.debounce(function () {
      // If you want to implement server-side search, do it here.
      // For client-side, the table's :filter prop is already bound to 'filter'.
    }, 300),
  },
  created: function () {
    this.getOrders();
  },
};
</script>

<style lang="css">
.country-flag {
  max-width: 20px;
  box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.9);
}

.background-white {
  background: #ffffff;
}

/*
 * Link
 */

/* Links */

.link {
  color: #484848;
}

/* unvisited link */
.link:link {
  color: #484848 !important;
}

/* visited link */
.link:visited {
  color: #484848 !important;
}

/* mouse over link */
.link:hover {
  color: #6e6e6e !important;
}

/* selected link */
.link:active {
  color: #484848 !important;
}
</style>